// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { DatabaseZap } from "lucide-react";
import { useTranslation } from "react-i18next";
import { DatabasePlusIcon } from "@/components/icons";
import { WizardPane } from "@/components/shared/wizard-pane";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

interface CreateTransformationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function CreateTransformationDialog({ open, onOpenChange }: CreateTransformationDialogProps) {
  const { t } = useTranslation("back-office");

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        id="dialog-create-transformation"
        className="sm:max-w-[37rem] p-0 gap-0 overflow-hidden flex flex-col"
        aria-describedby={undefined}
      >
        <div className="flex flex-row">
          <WizardPane icon={DatabasePlusIcon} />
          <div className="flex-1 p-6 flex flex-col gap-4 min-w-0">
            <DialogHeader>
              <DialogTitle>{t("transformations.dialog.createTitle")}</DialogTitle>
            </DialogHeader>

            <div className="flex flex-col items-center justify-center py-8 text-center">
              <DatabaseZap className="h-12 w-12 text-muted-foreground mb-4" />
              <p className="text-sm text-muted-foreground">{t("transformations.dialog.comingSoon")}</p>
            </div>
          </div>
        </div>

        <DialogFooter className="mx-0 mb-0 rounded-none rounded-b-lg">
          <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
            {t("buttons.cancel")}
          </Button>
          <Button disabled>
            <DatabasePlusIcon className="h-4 w-4" />
            {t("buttons.create")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
